module.exports = __webpack_public_path__ + "static/media/face_recognition.740b32db.png";